import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dsf_collapsed", "dsf_collapse_text", "dsf_expand_text"]

import router from '@/router'
import AppNavigationItems from './AppNavigationItems.vue'

const LS_EXPAND_KEY = 'orcas_navbar_expand'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutSidebarNew',
  setup(__props) {

const expanded = Boolean(localStorage.getItem(LS_EXPAND_KEY))

const onCollapse = () => {
  localStorage.removeItem(LS_EXPAND_KEY)
}

const onExpand = () => {
  localStorage.setItem(LS_EXPAND_KEY, 'true')
}

const navigate = (e: CustomEvent) => {
  const route = e.detail
  if (route) {
    router.push({ path: route })
    window.scrollTo(0, 0)
  }
}

const onLogoClick = () => {
  router.push({ path: '/' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-navbar", {
    dsf_collapsed: !_unref(expanded),
    dsf_title: "FOR CARRIERS",
    dsf_collapsed_title: "CARRIERS",
    dsf_collapse_text: _ctx.$t('navigation.item.collapse'),
    dsf_expand_text: _ctx.$t('navigation.item.expand'),
    onNavigate: navigate,
    onExpand: onExpand,
    onCollapse: onCollapse,
    onLogoClick: onLogoClick
  }, [
    _createVNode(AppNavigationItems)
  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
}
}

})